import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  Tooltip,
  Icon,
  IconButton,
  withStyles,
  Card,
  CardHeader,
} from '@material-ui/core';

import { editStatus } from '@pingum/app-state-management/status/actions';
import StatusBadge from '../../../../widgets/StatusBadge';
import StatusEditor from '../StatusEditor';

import styles from './styles';

export class StatusListItemComponent extends React.Component {
  constructor(props) {
    super(props);

    this.state = { showEditModal: false };
  }

  patchStatus = ({
    id = this.props.status.id,
    ...request
  }) => {
    this.props.editStatus(id, request);
  }

  handleArchive = () => {
    this.props.editStatus(this.props.status.id, { archived: true });
  }

  handleUnarchive = () => {
    this.patchStatus({ archived: false });
  }

  handleMoveForward = () => {
    const currentStatusOrder = this.props.status.statusOrder;
    const newStatusOrder = this.props.nextStatus.statusOrder > currentStatusOrder

      ? this.props.nextStatus.statusOrder
      : this.props.nextStatus.statusOrder + 1;
    this.patchStatus({ statusOrder: newStatusOrder });
    this.patchStatus({
      id: this.props.nextStatus.id,
      statusOrder: currentStatusOrder,
    });
  }

  handleMoveBackward = () => {
    const currentStatusOrder = this.props.status.statusOrder;
    const newStatusOrder = this.props.previousStatus.statusOrder < currentStatusOrder

      ? this.props.previousStatus.statusOrder
      : this.props.previousStatus.statusOrder - 1;
    this.patchStatus({ statusOrder: newStatusOrder });
    this.patchStatus({
      id: this.props.previousStatus.id,
      statusOrder: currentStatusOrder,
    });
  }

  handleEditAction = () => {
    this.setState({ showEditModal: true });
  }

  handleEditClose = () => {
    this.setState({ showEditModal: false });
  }

  render() {
    const {
      status,
      classes,
    } = this.props;
    const { showEditModal } = this.state;

    return (
      <div>
        {
          showEditModal
            && <StatusEditor {...this.props} onClose={this.handleEditClose} />
        }
        <Card>
          <CardHeader
            title={status.name}
            avatar={<StatusBadge icon={status.icon} iconColor={status.iconColor} />}
            action={(
              <div>
                {
                  this.props.previousStatus
                    && (
                      <Tooltip title="Move Back">
                        <IconButton
                          onClick={this.handleMoveBackward}
                          className={`${classes.moveButton} move-backward`}
                          size="small"
                        >
                          <Icon>arrow_upward</Icon>
                        </IconButton>
                      </Tooltip>
                    )
                }

                {
                  this.props.nextStatus
                    && (
                      <Tooltip title="Move Forward">
                        <IconButton
                          onClick={this.handleMoveForward}
                          className={`${classes.moveButton} move-forward`}
                          size="small"
                        >
                          <Icon>arrow_downward</Icon>
                        </IconButton>
                      </Tooltip>
                    )
                }
                <Tooltip title="Edit Status">
                  <IconButton
                    onClick={this.handleEditAction}
                    className="edit-status"
                  >
                    <Icon>edit</Icon>
                  </IconButton>
                </Tooltip>
                {
                  !status.archived
                    && (
                      <Tooltip title="Archive">
                        <IconButton onClick={this.handleArchive}>
                          <Icon>delete</Icon>
                        </IconButton>
                      </Tooltip>
                    )
                }
                {
                  status.archived
                    && (
                      <Tooltip title="Restore">
                        <IconButton onClick={this.handleUnarchive}>
                          <Icon>restore_from_trash</Icon>
                        </IconButton>
                      </Tooltip>
                    )
                }
              </div>
            )}
          />
        </Card>
      </div>
    );
  }
}

StatusListItemComponent.propTypes = {
  status: PropTypes.object,
  nextStatus: PropTypes.object,
  previousStatus: PropTypes.object,
  editStatus: PropTypes.func.isRequired,
  classes: PropTypes.object,
};

StatusListItemComponent.defaultProps = {
  classes: {},
  nextStatus: undefined,
  previousStatus: undefined,
  status: { name: '' },
};

export const mapDispatchToProps
  = (dispatch) => ({ editStatus: (statusId, request) => dispatch(editStatus(statusId, request)) });

export default withStyles(styles)(connect(
  null,
  mapDispatchToProps,
)(StatusListItemComponent));
